import { useState } from 'react';
import { setAccountId } from '../utils/accountStorage';

export default function WebLogin({ onContinue, onResolvePin }) {
  const [pin, setPin] = useState('');
  const [pinOk, setPinOk] = useState(false);
  const [existingId, setExistingId] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const onPin = async () => {
    setBusy(true);
    setError(null);
    try {
      await onResolvePin(pin.trim());
      setPinOk(true);
    } catch (e) {
      setError(e.message || 'PIN не найден');
      setPinOk(false);
    } finally {
      setBusy(false);
    }
  };

  const onLogin = async (accountId) => {
    setBusy(true);
    setError(null);
    try {
      setAccountId(accountId);
      await onContinue(accountId);
    } catch (e) {
      setError(e.message || 'Ошибка входа');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="web-login">
      <h2>Btp-Scud</h2>
      <p className="hint">Вход в веб-приложение</p>

      <section>
        <h3>PIN организации</h3>
        <input
          type="password"
          inputMode="numeric"
          placeholder="PIN регистрации"
          value={pin}
          onChange={(e) => { setPin(e.target.value); setPinOk(false); }}
        />
        <button type="button" onClick={onPin} disabled={busy || !pin.trim()}>Подтвердить PIN</button>
        {pinOk ? <p className="ok">Организация привязана</p> : null}
      </section>

      <section>
        <h3>Вход</h3>
        <button type="button" disabled={busy || !pinOk} onClick={() => onLogin(null)}>
          Войти на этом устройстве
        </button>
      </section>

      <section>
        <h3>Уже есть учётная запись</h3>
        <input
          placeholder="ID учётной записи"
          value={existingId}
          onChange={(e) => setExistingId(e.target.value)}
        />
        <button
          type="button"
          disabled={busy || !existingId.trim()}
          onClick={() => onLogin(existingId.trim())}
        >
          Войти по ID
        </button>
      </section>

      {error ? <p className="error">{error}</p> : null}
    </div>
  );
}
